import { useConfirm } from '@beyond-js/ui/react';
import { usePresence } from '@accounts/session';

/**
 * The copy the shared confirmation needs in the interface language: the family's own set (0.7.2), with
 * its close button, its failure line and the headings of a consequence ("What is lost", "What is kept",
 * "How to undo"). A screen passes it to `useConfirm`, and names the action's own verb as `accept` on
 * each question. One frozen set per language, so it changes only with the language.
 */
export function useQuestions() {
	const { language } = usePresence();
	return useConfirm.labels[language];
}
